module.exports = __webpack_public_path__ + "img/companion.2ba6599a.png";